export default __webpack_public_path__ + "static/media/middleware-logo.ebc35fc1.png";